import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "../../../components/FormControl";
import Select from "@mui/material/Select";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import CloseIcon from '@mui/icons-material/Close';

export default function CompanyAccessDialog({
  editDialogOpen,
  handleDialogClose,
  userId,
  orgId,
  ...props
}) {
  const [organization, setOrganization] = useState([
    {
      value: "key1",
      text: "key1",
    },
  ]);
  const [details, setDetails] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    axios
      .get(
        BaseURL.settings.GetDetailsToAddCompanyAccess +
        "?userId=" +
        userId +
        "&organizationId=" +
        orgId
      )
      .then((res) => {
        if (res?.data?.status == false) console.error(res?.data);
        if (res.data?.data) {
          setDetails(res.data?.data);
          // console.log(res.data.data);
          setOrganization([
            {
              value: orgId.toString(),
              text: res.data.data?.name,
            },
          ]);
          // console.log(orgId,res.data.data?.organizationId, organization);

          let ROLES = res.data.data?.rolesList?.map((role) => {
            return {
              value: role.roleId,
              text: role.roleName,
            };
          })?.sort((a, b) => a.text.localeCompare(b.text));
          setSelectedroles(res.data.data?.roles_CheckBoxStatus);
          setRoles(ROLES);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const [selectedRoles, setSelectedroles] = useState([]);
  const onSubmit = async () => {
    setIsSaving(true);

    const roleList = details.rolesList
      .filter((pair) => selectedRoles.includes(pair.roleId))
      .map((role) => {
        return {
          roleName: "string",
          organizationType: "string",
          orgRank: 0,
          roleId: role.roleId,
        };
      });

    if (roleList?.length > 0) {

      let data = {
        organizationId: orgId,
        name: "string",
        userId: userId,
        isEdit: true,
        oldOrgId: 0,
        roles_CheckBoxStatus: selectedRoles,
        rolesList: roleList,
      };

      const resp = await axios.post(BaseURL.settings.AddCompanyAccess, data);
      if (resp.data?.responseMessage.includes("Successfully")) {
        handleDialogClose();
        setIsSaving(false);
        toast.success(resp.data?.responseMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        setIsSaving(false);
        toast.error(resp.data?.responseMessage, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      toast.error("Please Select Atleast one Role", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsSaving(false);
    }
  };

  function handleRolesChange(data) {
    setSelectedroles(data);
  }
  return (
    <>
      {" "}
      <Dialog open={true} onClose={handleDialogClose} className="w-100 p-2">
        <DialogTitle id="companyAccess-dialog-title">
          {"Add Company Access"}
          <span className='mx-2' onClick={handleDialogClose} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
        </DialogTitle>
        <DialogContent sx={{ m: 2, width: 450 }}>
          <DialogContentText id="companyAccess-dialog-description">
            <Box className="d-flex">
              <FormControl
                className="w-100"
                fieldId={"orgId"}
                required={false}
                label={"Organization"}
                inputType="select"
                items={organization}
                value={details.organizationId || ""}
                width={"100%"}
                disabled={false}
                heighlight={"false"}
              />
            </Box>

            <Box className="d-flex">
              <FormControl
                className="w-100"
                fieldId={"rolesIds"}
                required={false}
                label={"User Roles"}
                inputType="select"
                multiple={true}
                items={roles}
                value={selectedRoles || ""}
                handleChange={(value) => handleRolesChange(value)}
                width={"100%"}
                disabled={false}
                heighlight={"false"}
              />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}> Cancel</Button>
          {isSaving ? (
            <Box
              style={{
                display: "flex",
                marginLeft: "auto",
                padding: "5px",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Button
              variant="contained"
              onClick={onSubmit}
              style={{ marginLeft: "auto", padding: "12px" }}
            >
              Save{" "}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ToastContainer />

    </>
  );
}
